<template>
  <div>
    <Head title="Delivery Run" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/dispatches/delivery-runs/${delivery_run.id}/orders`">Delivery Runs</Link>
      <span class="text-orange-400 font-medium">/</span>{{ delivery_run.number }}/{{ user.username }}/Orders/{{ order.order_no }}
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="search.search" class="mr-4 w-full max-w-md" @reset="reset" />
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div class="px-2 py-2 mb-3 mt-3">
        <h1 class="mb-3 text-1xl">
          <strong>Customer: </strong> {{ customer.name }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Contact: </strong>{{ customer.phone }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Physcial Address: </strong>{{ customer.physical_address }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Channel: </strong> {{ customer.channel }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Region: </strong>{{ customer.region }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>City: </strong>{{ customer.city }}
        </h1>
      </div> 
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Ordered</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Packed</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Delivered</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Returned</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Received</th>
          <th class="pb-3 pt-3 px-3 text-center">Volume</th>
          <th class="pb-3 pt-3 px-3">UoM</th>
          <th v-show="is_partial" class="pb-3 pt-3 px-3">Reason</th>
        </tr>
        <tr v-for="list in order_details.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ list.sku }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ list.description }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500" >
              {{ list.quantity }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500" >
              {{ list.quantity_packed }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500" >
              {{ list.quantity_delivered }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500" >
              {{ list.quantity_returned }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500" >
              {{ list.quantity_received }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500" >
              {{ list.volume }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center  px-3 py-3 focus:text-orange-500">
              {{ list.measure }}
            </span>
          </td>
          <td v-show="is_partial" class="border-t">
            <span class="flex items-center  px-3 py-3 focus:text-orange-500">
              {{ list.reason }}
            </span>
          </td>
        </tr>
        <tr v-if="order_details.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="5">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="order_details.links" />
  </div>
</template>
      
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'
      
export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
    SelectInput,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    order: Object,
    order_details: Object,
    user: Object,
    customer: Object,
    delivery_run: Object,
    orders: Object,
    is_partial: Number,
  },
  data() {
    return {
      search: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/dispatches/delivery-runs/${this.delivery_run.id}/orders/${this.order.id}/skus`, pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
  },
}
</script>
      